<template>
  <div>
    <GlobalInfoBar :title="this.$route.query.agent_id?'编辑代理商':'新增代理商'"/>
    <GlobalChunk
        :padding="[20,20,20,20]">
      <el-form ref="form" :model="form" label-width="100px" size="medium" :rules="rules">

        <el-form-item label="所属渠道" prop="pass_id">
          <el-select size="small" v-model="form.pass_id" placeholder="请选择渠道">
            <el-option
                v-for="item in channelList"
                :key="item.pass_id"
                :label="item.pass_name"
                :value="item.pass_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="代理商名称" prop="agent_name">
          <el-input v-model="form.agent_name" placeholder="请输入代理商名称"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入代理商联系电话" maxlength="11" type="tel"></el-input>
        </el-form-item>

        <el-form-item label="省市区" prop="region">
          <el-cascader :props="region" v-model="form.region" ref="cascader"></el-cascader>
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入代理商详细地址"></el-input>
        </el-form-item>

        <div style="margin-left: 100px;">
          <el-button type="primary" plain size="medium" @click="$router.go(-1)">返回</el-button>
          <el-button type="primary" size="medium" @click="confirm">提交</el-button>
        </div>
      </el-form>
    </GlobalChunk>
  </div>
</template>

<script>
import {
  addEditAgent,
  agentInfo,
  getRegion, selectPass
} from "../../../utils/request/changePhone";
import axios from "axios";

export default {
  name: "operate",
  data() {
    let regionValidate = (rule, value, callback) => {
      if (!value || (Array.isArray(value) && !value.length)) {
        callback('请选择区域')
        return
      }
      callback()
    };
    return {
      form: {
        pass_id: '',
        agent_name: '',
        phone: '',
        region: [],
        address: ''
      },
      channelList: [],
      rules: {
        pass_id: [{required: true, message: '请选择渠道', trigger: 'change'}],
        agent_name: [{required: true, message: '请输入代理商名称', trigger: 'change'}],
        phone: [{required: true, message: '请输入代理商联系电话', trigger: 'change'}],
        address: [{required: true, message: '请输入代理商详细地址', trigger: 'change'}],
        region: [  { required: true,validator: regionValidate, trigger: 'change' }],
      },
      region: {
        lazy: true,
        lazyLoad(node, resolve) {
          let pid = node.data && node.data.value || 0;
          getRegion({pid}).then(res => {
            let data = res || {};
            let children = []
            Object.keys(data).forEach(key => {
              children.push({
                value: key,
                label: data[key],
                leaf: node.level >= 2
              })
            })
            resolve(children)
          })
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.agent_id) {
      this.getAgentDetail()
    }
    this.getChannelList();
  },
  methods: {
    getAgentDetail() {
      agentInfo({
        agent_id: this.$route.query.agent_id
      }).then(res => {
        let data = res.data;
        if (data) {
          this.form = data
          this.form.region = [data.province, data.city, data.district]
          this.$refs.cascader.inputValue = [data.province_name, data.city_name, data.district_name].join(' / ');
        }
      })
    },
    getChannelList() {
      selectPass().then(res=>{
        this.channelList=res.data||[]
      })
    },
    confirm() {
      this.$refs.form.validate(valid=>{
        if (valid) {
          addEditAgent({
            agent_id: this.form.agent_id || '',
            pass_id:this.form.pass_id,
            agent_name:this.form.agent_name,
            phone:this.form.phone,
            province: this.form.region[0],
            city: this.form.region[1],
            district: this.form.region[2],
            address: this.form.address,
          }).then(data=>{
            this.$router.go(-1)
            this.$message.success(data&&data.msg||'操作成功')
          }).catch(err=>{
            console.error(err)
          })
        }
      })
    }

  }
}
</script>

<style scoped>
.el-input, .el-cascader,.el-select {
  width: 420px;
}
</style>
